/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ValidatorsService {
  constructor() {}

  getCompareValidator(formGroup: FormGroup, errorName: string, otherControlName: string, controlName: string) {
    if (formGroup) {
      const errors = formGroup.get(otherControlName).errors || {};
      if (!this.doFieldsMatch(formGroup, controlName, otherControlName)) {
        errors[errorName] = true;
        formGroup.get(otherControlName).setErrors(errors);
        const errorRes = {};
        errorRes[errorName] = true;
        return errorRes;
      } else {
        if (errors[errorName]) {
          delete errors[errorName];
        }
        formGroup.get(otherControlName).setErrors(Object.keys(errors).length === 0 ? null : errors);
      }
    }
  }

  private doFieldsMatch(formGroup: FormGroup, controlName: string, otherControlName) {
    if (formGroup) {
      return formGroup.get(controlName).value === formGroup.get(otherControlName).value;
    } else {
      return false;
    }
  }
}
